import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";

// Table columns names reference for diferent languages (implemented for "react-table" hook)
export const useColumns = ( context ) => {

    const getColumnsBillingPlan = () => {
        return [
            {
                Header: context.t('Id'),
                accessor: 'id',
            },
            {
                Header: context.t('Internal Name'),
                accessor: 'snx_name',
            },
            {
                Header: context.t('Internal Description'),
                accessor: 'snx_description',
            },
            {
                Header: context.t('Business Name'),
                accessor: 'business_name',
            },
            {
                Header: context.t('Business Description'),
                accessor: 'business_description',
            },
            {
                Header: context.t('Enable'),
                accessor: 'enabled',
            },
            {
                Header: context.t('Created At'),
                accessor: 'created_at',
            },
            {
                Header: context.t('Deleted At'),
                accessor: 'deleted_at',
            }
        ]
    };

    const getColumnsConfigurationElements = () => {
        return [
            {
                Header: context.t('Id'),
                accessor: 'id',
            },
            {
                Header: context.t('Name'),
                accessor: 'name',
            },
            {
                Header: context.t('Cost'),
                accessor: 'cost',
            },
            {
                Header: context.t('Currency'),
                accessor: 'currency',
            },
            {
                Header: context.t('Excedent'),
                accessor: 'excedent',
            },
            {
                Header: context.t('Percentage'),
                accessor: 'percentage',
            },
            {
                Header: context.t('Quantity'),
                accessor: 'quantity',
            },
            {
                Header: context.t('Monitoring'),
                accessor: d => d.monitoring.toString(),
            },
            {
                Header: context.t('Billing'),
                accessor: d => d.billing.toString(),
            }
        ]
    };

    const getColumnsConfigurationElementsInPlan = () => {
        return [
            {
                Header: context.t('Id'),
                accessor: 'element_id',
            },
            {
                Header: context.t('Name'),
                accessor: 'name',
            },
            {
                Header: context.t('Cost'),
                accessor: 'cost',
            },
            {
                Header: context.t('Currency'),
                accessor: 'currency',
            },
            {
                Header: context.t('Excedent'),
                accessor: 'excedent',
            },
            {
                Header: context.t('Percentage'),
                accessor: 'percentage',
            },
            {
                Header: context.t('Quantity'),
                accessor: 'quantity',
            },
            {
                Header: context.t('Monitoring'),
                accessor: d => d.monitoring.toString(),
            },
            {
                Header: context.t('Billing'),
                accessor: d => d.billing.toString(),
            }
        ]
    };

    const getColumnsBillingPlanInternal = () => {
        return [
            {
                Header: context.t('Id'),
                accessor: 'id',
            },
            {
                Header: context.t('Name'),
                accessor: 'snx_name',
            },            
            {
                Header: context.t('Item'),
                accessor: 'elements[0].name',
            },
            {
                Header: context.t('Cores'),
                accessor: 'elements[1].quantity',
            },
            {
                Header: context.t('Price'),
                accessor: 'elements[0].cost',
            },
            {
                Header: context.t('Internal Description'),
                accessor: 'snx_description',
            },
            {
                Header: context.t('Created At'),
                accessor: 'created_at',
            }
        ]
    };

    const getColumnsBillingPlanAccount = () => {
        return [
            {
                Header: context.t('Id'),
                accessor: 'id',
            },
            {
                Header: context.t('Plan Id'),
                accessor: 'account.plan.snx_name',
            },
            {
                Header: context.t('Account ID'),
                accessor: 'account.name',
            },
            {
                Header: context.t('Start At'),
                accessor: 'start_at',
            },
            {
                Header: context.t('End At'),
                accessor: 'end_at',
            },
            {
                Header: context.t('Create At'),
                accessor: 'created_at',
            },
            {
                Header: context.t('Deleted At'),
                accessor: 'deleted_at',
            }
        ]
    };

    const getColumnsSnxBillingAccountPlan = () => {
        return [
            {
                Header: context.t('Id PE'),
                accessor: 'id_plan_element',
            },
            {
                Header: context.t('Id Plan'),
                accessor: 'id_plan',
            },
            {
                Header: context.t('Id Element'),
                accessor: 'element_id',
            },
            {
                Header: context.t('Internal Name'),
                accessor: 'snx_name',
            },
            {
                Header: context.t('Internal Plan Description'),
                accessor: 'snx_description',
            },
            {
                Header: context.t('Plan Name'),
                accessor: 'business_name',
            },
            {
                Header: context.t('Plan Description'),
                accessor: 'business_description',
            },
            {
                Header: context.t('Plan Enabled'),
                accessor: 'plan_enabled',
            },
            {
                Header: context.t('Name'),
                accessor: 'name',
            },
            {
                Header: context.t('Item Name'),
                accessor: 'name_client',
            },
            {
                Header: context.t('Description'),
                accessor: 'description',
            },
            {
                Header: context.t('Item Description'),
                accessor: 'desc_client',
            },
            {
                Header: context.t('Quantity'),
                accessor: 'quantity',
            },
            {
                Header: context.t('Cost'),
                accessor: 'cost',
            },
            {
                Header: context.t('Surplus'),
                accessor: 'excedent',
            },
            {
                Header: context.t('Percentage'),
                accessor: 'percentage',
            },
            {
                Header: context.t('Surplus Cost'),
                accessor: 'discount_cost',
            },
            {
                Header: context.t('Surplus Discount'),
                accessor: 'discount_excd',
            },
            {
                Header: context.t('Billing'),
                accessor: 'billing',
            },
            {
                Header: context.t('Monitoring'),
                accessor: 'monitoring',
            },
            {
                Header: context.t('Currancy'),
                accessor: 'currency',
            },
            {
                Header: context.t('Element Start At'),
                accessor: 'element_start_at',
            },
            {
                Header: context.t('Element End At'),
                accessor: 'element_end_at',
            },
            {
                Header: context.t('Element Created At'),
                accessor: 'element_created_at',
            },
            {
                Header: context.t('Element Deleted At'),
                accessor: 'element_deleted_at',
            },
            {
                Header: context.t('Ele Conf Start At'),
                accessor: 'plan_element_config_start_at',
            },
            {
                Header: context.t('Ele Conf End At'),
                accessor: 'plan_element_config_end_at',
            },
            {
                Header: context.t('Ele Conf Created At'),
                accessor: 'plan_element_config_created_at',
            },
            {
                Header: context.t('Ele Conf Del At'),
                accessor: 'plan_element_config_deleted_at',
            },
            {
                Header: context.t('Created At'),
                accessor: 'plan_created_at',
            },
            {
                Header: context.t('Delete At'),
                accessor: 'plan_deleted_at',
            }
        ]
    };

    
    return {
        getColumnsBillingPlan,
        getColumnsConfigurationElements,
        getColumnsConfigurationElementsInPlan,
        getColumnsBillingPlanInternal,
        getColumnsBillingPlanAccount,
        getColumnsSnxBillingAccountPlan,
    }
    
}
